import { mergeDeepRight } from 'ramda'

export default async function (url, options = {}) {
  let defaultOptions = {
    headers: {
      Accept: 'application/json',
      'accept-language': sessionStorage.getItem('lang'),
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }

  return fetch(url, mergeDeepRight(defaultOptions, options)).then(res => {
    if (!res.ok) throw res
    return res
  })
}
